import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, Form, FormItem, InputItem, TextAreaItem, ErrorItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import rmaPdf from "../../../../Pdf/rmaPdf";
import { mostrarPdfEnIframe } from "../rmaComun";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Vista previa del PDF del RMA, descarga y envío por correo al cliente.
class MandarCorreoRMA extends Component {
  formRef = React.createRef();
  iframeRef = React.createRef();
  urlPdf = null;
  state = { loading: false, datos: null };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) this.consultarTodo();
  }

  componentWillUnmount() {
    if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
  }

  async consultarTodo() {
    this.setState({ loading: true, datos: null });
    try {
      const res = await axios.post(
        "rma/datosPdf",
        { rmaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (res.data.success !== 2) {
        message.warning(res.data.message || "No se pudo cargar el RMA");
        this.cerrarModal();
        return;
      }
      this.setState({ datos: res.data });
      // El correo del contacto del RMA se propone como primer destinatario.
      const correoContacto = (res.data.rma?.correoContacto || "").trim();
      if (correoContacto) this.formRef.current?.setFieldsValue({ correosEnvio: [{ correo: correoContacto }] });
      this.urlPdf = await mostrarPdfEnIframe(pdfMake.createPdf(rmaPdf(res.data)), this.iframeRef.current, this.urlPdf);
    } catch (e) {
      message.error("No se pudo cargar el RMA");
    } finally {
      this.setState({ loading: false });
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!(values?.correosEnvio?.length > 0)) return message.info("Proporcione al menos un correo de envío");
    this.setState({ loading: true });
    axios
      .post(
        "rma/enviarCorreo",
        { ...values, rmaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("RMA enviado");
          this.cerrarModal();
        } else {
          message.error(res.data.message || "Sucedió un error y no se pudo enviar");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Sucedió un error y no se pudo enviar");
      });
  }

  cerrarModal() {
    this.props.onCerrar();
    this.formRef.current?.resetFields();
  }

  descargarPdf() {
    if (!this.state.datos) return;
    pdfMake.createPdf(rmaPdf(this.state.datos)).download(`RMA ${this.state.datos.rma?.folio || ""}.pdf`);
  }

  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreoRMA"
          layout
          width={700}
          onCancel={this.cerrarModal.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem name={[name, "correo"]} fieldKey={[arrayKey, "correo"]} label="Correo" required margin email pattern>
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <FormItem name="mensaje" label="Mensaje" margin>
            <TextAreaItem placeholder="Mensaje que acompaña al correo (opcional)" rows={2} />
          </FormItem>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem type="primary" blanco onClick={this.descargarPdf.bind(this)}>
                Descargar
              </ButtonItem>
              <ButtonItem type="primary" htmlType="submit">
                Mandar Correo
              </ButtonItem>
              <ButtonItem type="primary" danger onClick={this.cerrarModal.bind(this)}>
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe ref={this.iframeRef} title="rmaPdf" style={{ width: "100%", height: "100vh", border: 0 }} />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(MandarCorreoRMA);
